//@ts-check
import Utils from '../../../../utils';

var getProjectByName = function getProjectByName(name) {
  return Utils.request({
    url: '/backend/communications',
    query: {
      name: name
    }
  });
};

var getProjectByUid = function getProjectByUid(uid) {
  return Utils.request({
    url: '/backend/communications',
    query: {
      uid: uid
    }
  });
};
/**
 * Request for a job summary based on jobId and workspace
 * @param {string} jobId
 * @param {string} workspace
 * @return {Promise<import('./types').JobSummary>} Returns job summary
 */


var getJobById = function getJobById(jobId, workspace) {
  return Utils.request({
    url: '/backend/jobsummary',
    query: {
      id: jobId,
      workspace: workspace
    }
  });
};
/**
 * @param {string} workspace
 * @param {string} workflowPath
 * @param {string} inputData
 * @param {Array<{Name:string, Value:string}>} jobParameters
 */


var getTemplates = function getTemplates(workspace, workflowPath) {
  var inputData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var jobParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return Utils.request({
    method: 'POST',
    url: '/backend/workflowtemplates',
    data: {
      workspace: workspace,
      workflowPath: workflowPath,
      inputData: inputData,
      jobParameters: jobParameters,
      TestRunConditions: true
    }
  });
};
/**
 * Run form xml on the backend server and return result (in most cases, form xml is used in a EDX diagram that must be executed by the DAS Engine)
 * @param {string} workspace
 * @param {string} workflowPath
 * @param {string} input
 * @param {Array<{Name:string, Value:string}>} jobParameters
 * @param {string} jobId
 * @param {number} version this is the communication version (for version equals 1 do not process data)
 */


var processInput = function processInput(workspace, workflowPath, input, jobParameters, jobId) {
  var version = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  if (version === 1) return Promise.resolve(input);
  return Utils.request({
    method: 'POST',
    url: '/backend/runDasDiagram',
    data: {
      Workspace: workspace,
      WorkflowPath: workflowPath,
      InputData: input,
      JobParameters: jobParameters,
      JobId: jobId
    }
  });
};

var runCommunication = function runCommunication(communicationName, jobId, inputData) {
  var deffer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var test = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return Utils.request({
    method: 'PUT',
    url: '/backend/communicationrun',
    contentType: 'json',
    data: {
      JobId: jobId,
      Name: communicationName,
      Input: inputData,
      DefferStart: deffer,
      TestMode: test
    }
  });
};

var startJob = function startJob(communicationName, jobId, jobName, inputData) {
  var deffer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var parameters = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var test = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var workItemPath = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var workItemWorkspace = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  return Utils.request({
    method: 'POST',
    url: '/backend/communicationrun',
    contentType: 'json',
    data: {
      JobId: jobId,
      Name: communicationName,
      JobName: jobName || null,
      Input: inputData,
      DefferStart: deffer,
      JobParameters: parameters,
      TestMode: test,
      WorkItemPath: workItemPath,
      WorkItemWorkspace: workItemWorkspace
    }
  });
};
/**
 * @param {string} workspace
 * @param {string} id
 * @param {string} input
 * @returns {Promise<string>}
 */


var setJobInput = function setJobInput(workspace, id, input) {
  return Utils.request({
    method: 'POST',
    contentType: 'json',
    url: '/backend/jobs',
    query: {
      id: id,
      workspace: workspace
    },
    data: JSON.stringify(input)
  });
};

var data = {
  getProjectByName: getProjectByName,
  getProjectByUid: getProjectByUid,
  getJobById: getJobById,
  getTemplates: getTemplates,
  runCommunication: runCommunication,
  startJob: startJob,
  setJobInput: setJobInput,
  processInput: processInput
};
export default data;